import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function ArrowRight(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path
        d="M12.2578 15.1011C11.9258 14.7692 11.9258 14.231 12.2578 13.8991L17.3068 8.8501L0.999877 8.8501C0.530434 8.8501 0.149876 8.46954 0.149876 8.0001C0.149876 7.53065 0.530434 7.1501 0.999877 7.1501L17.3068 7.1501L12.2578 2.10114C11.9258 1.76919 11.9258 1.231 12.2578 0.899056C12.5897 0.56711 13.1279 0.56711 13.4599 0.899056L20.5609 8.0001L13.4599 15.1011C13.1279 15.4331 12.5897 15.4331 12.2578 15.1011Z"
        fill="#5F606D"
      />
    </IconWrapper>
  );
}
